import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoicingState, Order } from 'models/order';
import { Button, Box, Divider } from '@mui/material';

type CreateInvoiceButtonProps = {
    order: Order;
    isManual: boolean;
    onToggleOrderDoNotInvoice: (isDoNotInvoice: boolean) => void;
    onCreateInvoice: () => void;
    disabled?: boolean;
};
const CreateInvoiceButton: FC<CreateInvoiceButtonProps> = ({
    order,
    isManual,
    onToggleOrderDoNotInvoice,
    onCreateInvoice,
    disabled,
}: CreateInvoiceButtonProps) => {
    const { t: translate } = useTranslation(['orders', 'invoices']);
    const handleClick = (value: boolean) => {
        onToggleOrderDoNotInvoice(value);
    };

    const createInvoice = () => {
        onCreateInvoice();
    };

    return (
        <Fragment>
            {order.invoicingState !== InvoicingState.SHOULD_NOT_INVOICE && (
                <Box mb={2}>
                    <Button
                        disabled={
                            disabled ||
                            (isManual && !order.tempInvoiceNumber) ||
                            !order?.deliveryDetails?.price ||
                            order?.deliveryDetails?.price === 0 ||
                            order.invoicingState !== InvoicingState.NOT_READY
                        }
                        fullWidth
                        variant="contained"
                        disableElevation
                        onClick={createInvoice}
                        data-test="invoice-actions.create-invoice"
                    >
                        {translate('invoices:CREATE_INVOICE')}
                    </Button>
                </Box>
            )}

            <Box mt={1} mb={1}>
                <Divider />
            </Box>

            {order.invoicingState === InvoicingState.NOT_READY ? (
                <Box>
                    <Button
                        fullWidth
                        size="small"
                        onClick={() => handleClick(true)}
                        data-test="invoice-actions.do-not-invoice"
                    >
                        {translate('orders:DO_NOT_INVOICE')}
                    </Button>
                </Box>
            ) : undefined}

            {order.invoicingState === InvoicingState.SHOULD_NOT_INVOICE && (
                <Box>
                    <Button
                        fullWidth
                        size="small"
                        color="warning"
                        onClick={() => handleClick(false)}
                        data-test="invoice-actions.undo-do-not-invoice"
                    >
                        {translate('orders:UNDO_DO_NOT_INVOICE')}
                    </Button>
                </Box>
            )}
        </Fragment>
    );
};

export default CreateInvoiceButton;
